import * as types from './actionTypes';
import userAPI from '../services/userAPI';

export function loadUsersSuccess(users) {
    return { type: types.LOAD_USERS_SUCCESS, userList: users};
}

export function addUserSuccess(user) {
  return { type: types.ADD_USER_SUCCESS, user};
}

export function deleteUserSuccess(id) {
  return { type: types.DELETE_USER_SUCCESS, id};
}
  
export function loadUsers() {
  return function(dispatch) {
    return userAPI.getAll().then(users => {console.log("getAll users:" + JSON.stringify(users)); dispatch(loadUsersSuccess(users)); } ).catch( error => { throw(error); });
  };
}
  
export function addUser(user) {
  return function (dispatch, getState) {
    return userAPI.saveUser(user).then(user => {
      dispatch(addUserSuccess(user));
    }).catch(error => {
      throw(error);
    });
  };
}
  
export function deleteUser(id) {
  return function (dispatch, getState) {
    return userAPI.delete (id).then(() => {
      dispatch(deleteUserSuccess(id));
    }).catch(error => {
      throw(error);
    });
  };
}
